import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  progress: number;
  total: number;
  label?: string;
};

export const LoadingProgress = ({ progress, total, label }: Props) => {
  const { translations } = useLanguage();
  const percentage = Math.round((progress / total) * 100);

  return (
    <div className="bg-primary-50 p-2 rounded-lg">
      <div className="flex justify-between text-sm text-primary-600">
        <span>{label || translations?.loadingProgress?.loading || 'Loading...'}</span>
        <span>{percentage}%</span>
      </div>
      <div className="mt-1 h-1 bg-primary-100 rounded-full overflow-hidden">
        <motion.div 
          className="h-full bg-primary-500 transition-all duration-300"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};